<template>
	<div class="tags-list">
		<template v-if="tagsItems.length">
			<div v-for="tagsItem in tagsItems" :key="tagsItem.name" class="tags-list__item" :class="{'tags-list__item--dark' : dark}">
				<span class="tags-list__item-name">{{ tagsItem.name }}</span>
			</div>
		</template>

		<div v-else class="tags-list__empty">Товаров не найдено</div>
	</div>
</template>

<script>
export default {
	name: "TagsLIst",
	props: {
		tagsItems: {
			type: Array,
			default: () => []
		},
		dark: {
			type: Boolean,
			default: false
		}
	},
}
</script>

